const sortingData = {
  dateDesc: {
    label: 'dateDesc',
    name: 'New to old',
    icon: 'ArrowDown'
  },
  dateAsc: {
    label: 'dateAsc',
    name: 'Old to new',
    icon: 'ArrowUp'
  },
  alphaAsc: {
    label: 'alphaAsc',
    name: 'A to Z',
    icon: 'ArrowDown'
  },
  alphaDesc: {
    label: 'alphaDesc',
    name: 'Z to A',
    icon: 'ArrowUp'
  }
};

export default sortingData;


// WEBPACK FOOTER //
// ./src/data/sorting.js